import qs from "query-string";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  ensureTrailingSlash,
  generateSpecificSearchPattern,
  getBaseUrl,
  RideRoutes,
  RIDES_URL,
  ridesIdSearchRefetchTokenAtom,
  saveLastNavigation,
  starredDisplayModeAtomFamily,
  StarredDisplayModeEnum,
  tableSearchAF,
  usePrefixedRouting,
} from "@ryde/shared";

export const useRidesByIdsNavigation = () => {
  const { navigatePrefixed, addPrefix } = usePrefixedRouting();
  const setTableSearch = useSetRecoilState(tableSearchAF("ride"));
  const setStarredDisplayMode = useSetRecoilState(
    starredDisplayModeAtomFamily("ride"),
  );
  const setIdSearchRefetchToken = useSetRecoilState(
    ridesIdSearchRefetchTokenAtom,
  );

  const navigateToRidesByIds = useEvent((rideIds: number[]): void => {
    if (!rideIds?.length) {
      return;
    }
    setStarredDisplayMode(StarredDisplayModeEnum.ShowAllIncludeStarred);
    setTableSearch(generateSpecificSearchPattern(rideIds));
    navigatePrefixed(RideRoutes.SEARCH_GRID_MULTI_SELECT);
    saveLastNavigation({
      route: RIDES_URL,
      path: RideRoutes.SEARCH_GRID_MULTI_SELECT,
    });
    setIdSearchRefetchToken(token => token + 1);
  });

  /**
   * Opens rides grid with `id:` search in a new browser tab.
   * Hash URL + `search` QS is hydrated by the grid on load (same idea as produce results).
   */
  const openRidesByIdsInNewTab = useEvent((rideIds: number[]): void => {
    if (!rideIds?.length) {
      return;
    }
    const searchPattern = generateSpecificSearchPattern(rideIds);
    const relativePath = addPrefix(
      `${RideRoutes.SEARCH_GRID_MULTI_SELECT}?${qs.stringify({ search: searchPattern })}`,
    );
    const ridesUrl = `${ensureTrailingSlash(getBaseUrl())}#${relativePath}`;
    window.open(ridesUrl, "_blank");
  });

  const navigation = { navigateToRidesByIds, openRidesByIdsInNewTab };
  return navigation;
};
